import Card from "components/card/Card"
import {
    EditablePreview,
    Editable,
    EditableInput,
    useEditableControls,
    Input,
    Flex,
    Heading,
    Link,
    IconButton,
    ButtonGroup,
    Spinner,
    Tooltip,
    Text, TableContainer, Tr, Thead, Tbody, Td, Table, Th, Spacer, SimpleGrid, Skeleton
} from "@chakra-ui/react"
import {gql, useQuery, useMutation} from "@apollo/client";
import {CheckIcon, CloseIcon, EditIcon, ChevronLeftIcon, ChevronRightIcon} from "@chakra-ui/icons";
import {BsGraphDown, BsGraphUp} from "react-icons/bs"
import {BiEditAlt} from "react-icons/bi";
import {FiArrowRight} from "react-icons/fi"
import StarRatings from 'react-star-ratings';
import {NavLink as ReactLink} from "react-router-dom";
import {GetThemeTextStatistics} from "views/home/themes/ThemeTopics";
import {platformToPlatformName} from "variables/constants"
import React, {useState} from "react";


const UpdateThemeDescription = gql`
mutation UpdateThemeDescription($description: String = "", $customer: String = "", $themeId: Int = 10) {
  update_themes(where: {theme_id: {_eq: $themeId}, customer: {_eq: $customer}}, _set: {description: $description}) {
    returning {
      description
    }
  }
}
`

function QuoteGrid({reasons, purpose}) {
    // Deduplicate reasons object based on text_id
    const [page, setPage] = useState(0);
    const maxRows = 5
    const reasons_slice = reasons.slice(page * maxRows, (page + 1) * maxRows)
    console.log("page", page)


    const GetTextsMetadata = gql`
    query GetTextsMetadata($_in: [String!] = "") {
      texts(where: {text_id: {_in: $_in}}) {
        timestamp_original
        review_rating: data(path: "$.review_rating")
        product {
          platform
        }
      }
    }
    `
    let {loading, error, data} = useQuery(GetTextsMetadata,
        {
            variables: {"_in": reasons_slice.map((x) => x[0].text_id)},
            skip: reasons_slice.length === 0
        },
    )
    if (error) console.log("GetTextsMetadata query failed", error)
    if (loading) return <Spinner/>
    if (!data || data.texts.length === 0) return (
        <Flex flexDirection="column" w="100%" display="block" borderWidth='1px' borderRadius='lg' overflowY='hidden'>
            <TableContainer whiteSpace="normal" overflowY="hidden">
                <Table variant='striped' colorScheme={purpose === 'positive' ? 'teal' : 'orange'} size='sm'
                       maxHeight="inherit">
                    <Thead>
                        <Tr>
                            <Th>{purpose === "positive" ? "Why users loved" : "Why users criticized"}</Th>
                            <Th>Topic</Th>
                        </Tr>
                    </Thead>
                </Table>
            </TableContainer>
        </Flex>
    )
    return (
        <Flex flexDirection="column" w="100%" borderWidth='1px' borderRadius='lg' overflowY='hidden'>
            <TableContainer whiteSpace="normal" overflowY="hidden">
                <Table variant='striped' colorScheme={purpose === 'positive' ? 'teal' : 'orange'} size='sm'
                       maxHeight="inherit">
                    <Thead>
                        <Tr>
                            <Th>{purpose === "positive" ? "Why users loved" : "Why users criticized"}</Th>
                            <Th>Topic</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {reasons_slice.map((x, idx) =>
                            <Tr key={idx}>
                                <Td pl="8px"><Tooltip
                                    label={`${x[0].text.text}`}><Text
                                    noOfLines={1}> {x[0].reason_text}</Text></Tooltip></Td>
                                <Td pr="8px" whiteSpace="normal"><Tooltip
                                    label={`${platformToPlatformName[data.texts[idx].product.platform]} on ${data.texts[idx].timestamp_original}`}>
                                    {x[1]}
                                    {/*</Tag>*/}
                                </Tooltip></Td>
                            </Tr>
                        )}
                    </Tbody>
                </Table>

            </TableContainer>
            <Spacer/>
            <Flex flexDirection="row">
                <IconButton
                    variant='outline'
                    size='sm'
                    borderRadius='md'
                    aria-label='Previous'
                    onClick={() => {
                        if (page > 0) {
                            setPage(page => page - 1)
                        }
                    }}
                    isDisabled={page === 0}
                    icon={<ChevronLeftIcon/>}/>
                <Spacer/>
                <IconButton
                    variant='outline'
                    size='sm'
                    borderRadius='md'
                    aria-label='Next'
                    onClick={() => {
                        if ((maxRows * (page + 1)) < reasons.length) {
                            setPage(page => page + 1)
                        }
                    }}
                    isDisabled={(maxRows * (page + 1)) >= reasons.length}
                    icon={<ChevronRightIcon/>}/>
            </Flex>
        </Flex>
    )
}

function selectReasonsToDisplay(reasons, toDisplay) {
    // Tries to select equidistant 'toDisplay' number of reasons
    if (toDisplay >= reasons.length) {
        return reasons;
    }
    let arr = [];
    let step = (reasons.length - 1) / (toDisplay - 1);
    for (let i = 0; i < toDisplay; i++) {
        arr.push(reasons[Math.round((step * i))]);
    }
    return arr;
}


function ThemeCardStatistics({themeId, themeDescription, arrowDirection = "up"}) {
    function EditableControls() {
        const {
            isEditing,
            getSubmitButtonProps,
            getCancelButtonProps,
            getEditButtonProps
        } = useEditableControls();
        return isEditing ? (
            <ButtonGroup justifyContent="end" size="sm" w="full" spacing={2} mt={2}>
                <IconButton icon={<CheckIcon/>} {...getSubmitButtonProps()} />
                <IconButton
                    icon={<CloseIcon boxSize={3}/>}
                    {...getCancelButtonProps()}
                />
            </ButtonGroup>
        ) : <Flex justifyContent='end'>
            <IconButton size='sm' icon={<EditIcon/>} {...getEditButtonProps()} />
        </Flex>;
    }

    const [editedDescription, setEditedDescription] = React.useState(themeDescription);
    const [mutateFunction, {
        data: mutationData,
        loading: mutationLoading,
        error: mutationError
    }] = useMutation(UpdateThemeDescription);
    let {loading, error, data} = useQuery(GetThemeTextStatistics,
        {
            variables: {
                "theme_id_arg": themeId,
                "interval_days": 30,
                "customer_name": localStorage.getItem("customerName")
            }
        }
    )
    if (error) console.log("GetThemeTextStatistics query failed", error)
    if (loading) return <Skeleton w="300px"/>
    console.log('ThemeCardStatistics data', data);
    let avgRating = data.theme_text_statistics_fn_fn_fn[0].avg_rating; // This will be null if things go wrong, Fallback then
    let positiveSentiment = avgRating ? Number((data.theme_text_statistics_fn_fn_fn[0].positives * 100 / (data.theme_text_statistics_fn_fn_fn[0].positives + data.theme_text_statistics_fn_fn_fn[0].negatives + data.theme_text_statistics_fn_fn_fn[0].neutrals)).toFixed(0)) : 70;
    let negativeSentiment = avgRating ? Number((data.theme_text_statistics_fn_fn_fn[0].negatives * 100 / (data.theme_text_statistics_fn_fn_fn[0].positives + data.theme_text_statistics_fn_fn_fn[0].negatives + data.theme_text_statistics_fn_fn_fn[0].neutrals)).toFixed(0)) : 24
    const negativeX = 0.495 * (100 - negativeSentiment)
    const negativeWidth = negativeSentiment * 0.495
    const positiveWidth = positiveSentiment * 0.495
    const positiveX = 50.5


    return (
        <Flex flexDirection='column' borderTop='1px' w='300px' mr='20px'>
            <Text as='b'>Description</Text>
            <Flex direction='row'>

                <Editable w="300px" value={editedDescription} isPreviewFocusable={false} onSubmit={(e) => {
                    console.log('description', editedDescription)
                    mutateFunction({
                        variables: {
                            themeId: themeId,
                            description: editedDescription,
                            customer: localStorage.getItem("customerName")
                        }
                    })
                }} onChange={(value) => {
                    setEditedDescription(value)
                }}><EditablePreview/> <Input
                    as={EditableInput}/>
                    <EditableControls/>
                </Editable>
            </Flex>

            <Text as='b' mt="20px" borderTop='1px'>Sentiment</Text>
            <svg width='100%' height='14px'>
                <g className='bars'>
                    <rect x='0%' y='2px' fill='#F1F1F1' width='100%' height='10px'/>

                    <rect fill='#FC8181' x={`${negativeX}%`} y='2px' width={`${negativeWidth}%`}
                          height='10px'/>
                    <rect fill='#68D391' x={`${positiveX}%`} y='2px' width={`${positiveWidth}%`}
                          height='10px'/>
                    <rect fill='#000000' x="49.5%" y="0px" width="1%" height="14px"/>
                </g>
            </svg>
            <Flex flexDirection='row' justifyContent='space-around' mb='5px'>
                <Flex flexDirection='column' alignItems='center'>
                    <Heading size='xs'>NEGATIVE</Heading>
                    <Flex flexDirection='column' alignItems='baseline' gap='0px'>
                        <Flex flexDirection='row'>
                            <Text fontSize='2xl' lineHeight='24px'>{negativeSentiment}</Text><Text>%</Text>
                        </Flex>
                        {/*<Text> -21%</Text>*/}
                    </Flex>
                </Flex>
                <Flex flexDirection='column' alignItems='center'>
                    <Heading size='xs'>POSITIVE</Heading>
                    <Flex flexDirection='column' alignItems='baseline' gap='0'>
                        <Flex flexDirection='row'>
                            <Text fontSize='2xl' lineHeight='24px'>{positiveSentiment}</Text><Text>%</Text>
                        </Flex>
                        {/*<Text>+15%</Text>*/}
                    </Flex>
                </Flex>
            </Flex>


            <Flex flexDirection='row' gap='20px'>
                <Flex flexDirection='column' width='50%'>
                    <Heading size='xs' mt="15px" borderTop='1px'>Activity (1 month)</Heading>
                    <Flex flexDirection='row' alignItems='baseline'>
                        <Text fontSize='2xl'>{data.theme_text_statistics_fn_fn_fn[0].count ?? 1202}</Text>
                        <Text> +{data.theme_text_statistics_fn_fn_fn[0].interval_count ?? 103}</Text>
                    </Flex>
                </Flex>
                <Flex flexDirection='column' width='50%'>
                    <Heading size='xs' mt="15px" borderTop='1px'>User Ratings</Heading>
                    <StarRatings
                        rating={data.theme_text_statistics_fn_fn_fn[0].avg_rating ?? 3.5}
                        starRatedColor="#7CB4F5"
                        starDimension='20px'
                        starSpacing='4px'
                        numberOfStars={5}
                        name='rating'
                    />
                </Flex>
            </Flex>

        </Flex>
    )
}

function GridSpace({reasons_positive, reasons_negative}) {

    return (
        <SimpleGrid columns={2} spacing={5} w="100%">
            <QuoteGrid reasons={reasons_positive} purpose="positive"/>
            <QuoteGrid reasons={reasons_negative} purpose="negative"/>
        </SimpleGrid>
    )
}

export default function ThemeCard({themeData}) {
    console.log("themeData", themeData)
    const themeId = themeData.theme_id
    const themeName = themeData.theme_name
    const themeDescription = themeData.description ?? "Edit Description"


    let reasons_negative = [];
    let reasons_positive = [];
    for (let topic of themeData.topics) {
        for (let def of topic.topic_definitions || []) {
            for (let reason of def.topic_definition_to_reasons || []) {
                if (reason.type === "positive_sentiment") {
                    reasons_positive.push([reason, topic.topic_name])
                } else if (reason.type === "negative_sentiment") {
                    reasons_negative.push([reason, topic.topic_name])
                }

            }
        }
    }
    reasons_negative = reasons_negative.filter((x, i, a) => a.findIndex(t => (t[0].text_id === x[0].text_id)) === i)
    reasons_positive = reasons_positive.filter((x, i, a) => a.findIndex(t => (t[0].text_id === x[0].text_id)) === i)
    return (
        <Card w='100%' pt='13px' pb='20px' px='20px'>
            <Flex flexDirection='column'>
                <Flex flexDirection='row' justifyContent='flex-start' alignItems='center' mb='20px'>
                    <Heading size='lg' mr="10px">{themeName}</Heading>
                    <Link to={`/home/analyzeTheme?theme_id=${themeId}`} as={ReactLink}>
                        <FiArrowRight size="24px" color="#F46818"/>
                    </Link>
                </Flex>
                <Flex flexDirection='row' h='300px'>
                    <ThemeCardStatistics themeId={themeId} themeDescription={themeDescription}
                                         arrowDirection={"up"}/>
                    <GridSpace reasons_positive={reasons_positive} reasons_negative={reasons_negative}/>
                </Flex>
            </Flex>
        </Card>
    )
}